import React, { useMemo } from 'react'

import { Context } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { object, array, string } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import FeaturedPosts from './Components/FeaturedPosts/FeaturedPosts'
import Section from './Components/Section/Section'
import Tabs from './Components/Tabs/Tabs'
import { featuredPostsCount } from './Static/Constants'

function Blog({ t, posts = EMPTY_ARRAY, categories = EMPTY_ARRAY, currentPathname }) {
  const isMainPage = currentPathname === '/blog'
  const splitPathname = currentPathname.split('/').filter((name) => !!name)

  const sortCategoriesByCustomOrder = (categoriesList) => {
    const customOrder = ['insight', 'news', 'interviews']

    return categoriesList.sort((a, b) => {
      const aIndex = customOrder.indexOf(a.slug)
      const bIndex = customOrder.indexOf(b.slug)

      if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex
      if (aIndex !== -1) return -1
      if (bIndex !== -1) return 1
      return 0
    })
  }

  const categoriesList = isMainPage
    ? sortCategoriesByCustomOrder(categories)
    : [
        categories.find(
          ({ slug }) => splitPathname[splitPathname.length - 1] === slug
        ),
      ].filter(Boolean)

  const visibleCategories = useMemo(() =>
    sortCategoriesByCustomOrder(
      categories.filter(({ visible }) => !!visible)
    ),
    [categories]
  )

  const contextValue = useMemo(
    () => ({ posts, currentPathname, t }),
    [posts, currentPathname, t]
  )

  const nonFeaturedPosts = posts.filter((_, i) => i >= featuredPostsCount)

  return (
    <Context.Provider value={contextValue}>
      <div className="blog">
        <div className="row justify-content-center">
          <div className="container-fixed site-page site-page--blog">
            <div className="col-12 col-xl-10 offset-xl-1 col-xxl-8 offset-xxl-2">
              {categories.length && <Tabs list={visibleCategories} />}

              {isMainPage && <FeaturedPosts />}

              {categoriesList?.map((category, index) => {
                const sectionPosts = isMainPage
                  ? nonFeaturedPosts.filter((post) => {
                      return post.categories.some(({ id }) => id === category.id)
                    })
                  : posts

                if (isMainPage && !sectionPosts?.length) return null

                return (
                  <Section
                    key={`${category.id}-${index}`}
                    category={category}
                    posts={
                      isMainPage
                        ? sectionPosts.filter((_, i) => i < featuredPostsCount)
                        : sectionPosts
                    }
                    isMainPage={isMainPage}
                  />
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </Context.Provider>
  )
}

Blog.propTypes = {
  posts: array,
  categories: array,
  currentPathname: string.isRequired,
  t: object.isRequired,
}

export default Blog
